import { HighlightOff } from "@mui/icons-material"
import React, { FC, useCallback, useMemo } from "react"

import { Button } from "src/components/common/button"
import { Drawer } from "src/components/common/drawer"
import { IconButton } from "src/components/common/iconButton"
import { BasicLayoutStyleProps } from "src/components/layouts/basic"

import { create } from "src/helpers/bem"
import {
  useBookingDetailPermissions,
  mergeBookingDetailPermissions,
  resetBookingDetailPermissions,
} from "src/states/bookingDetailPermissions"

import { mergeDialog } from "src/states/dialogs"
import { TranslationMessages } from "src/translations"

import styles from "./PermissionDialog.module.scss"
import { PermissionTable } from "./PermissionTable"

const bem = create(styles, "PermissionDialog")

export type PermissionDialogProps = {
  messages: TranslationMessages
  style: BasicLayoutStyleProps
}

export const PermissionDialog: FC<PermissionDialogProps> = ({
  messages,
  style,
}) => {
  const permissionMessages = messages.pages.booking.detail.actions.permissions
  const { open } = useBookingDetailPermissions()

  const handleCancel = useCallback(() => {
    mergeDialog("salesorderDialog", { open: true })
    resetBookingDetailPermissions()
  }, [])

  const closeDialog = () =>
    mergeBookingDetailPermissions({
      open: false,
    })

  return (
    <Drawer
      anchor="right"
      open={useMemo(() => open, [open])}
      style={style}
      title={permissionMessages.title}
      onClose={closeDialog}
      onOpen={() =>
        mergeBookingDetailPermissions({
          open: true,
        })
      }
    >
      <div className={bem()}>
        <div className={bem("header")}>
          <h2>{permissionMessages.title}</h2>
          <div className={bem("close")}>
            <IconButton
              color={"primary"}
              icon={HighlightOff}
              onClick={() => {
                closeDialog()
              }}
            />
          </div>
        </div>
        <PermissionTable messages={messages} />
        <div className={bem("footer")}>
          <Button
            buttonType="secondary"
            title={permissionMessages.cancel}
            onClick={handleCancel}
          />
        </div>
      </div>
    </Drawer>
  )
}
